import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Footer = styled.footer`
.footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: fixed;
  justify-content: space-between;
  bottom: 0;
  background-color: white !important;
  width: 100%;
  box-shadow: 0px 2px 0px 0px #7277801a;
  height: 56px; 
  left: 0;
  z-index: 3;
}

.left-item-footer {
  font-family: 'Public Sans', sans-serif;
  width: 300px;
  margin-left: 100px;
}

.report-int {
  text-align: center;
  margin-right: 15px; 
  white-space: nowrap; 
}

.all-footer {
  width: 100%;
  display: flex;
  font-size: 12px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
}

.links-educat {
  height: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.contato {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.email-footer,
.tel-footer {
  width: 100%; 
  max-width: 200px; 
  margin: 10px 0; 
}

.img-footer {
  margin-right: 20px; 
}

.logo {
  width: 80px;
}

@media (max-width: 600px) {
  .footer {
    flex-direction: column; 
    height: 150px; 
  }

  .all-footer {
    flex-direction: column; 
    align-items: center;
    text-align: center; 
  }

  .links-educat {
    flex-direction: column; 
    align-items: center;
  }

  .img-footer {
    margin: 10px 0; 
  }

  .report-int {
    display: none; 
  }

  .left-footer,
  .img-footer {
    margin: 0; 
  }
  .left-item-footer {
    font-family: 'Public Sans', sans-serif;
    width: 300px;
    margin-left: 5px; 
    display: flex;
  }
}
`;